import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Menu, X, Home, Info, MessageCircle, LogIn, LayoutDashboard } from 'lucide-react';
import Logo from '../../assets/images/logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { state } = useAuth();
  const location = useLocation();
  const token = state?.isAuthenticated;
  const admin = localStorage.getItem('adminUsrtoken') || localStorage.getItem('adminToken');;
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const navLinks = [
    { path: '/', label: 'Home', icon: Home },
    { path: '/about', label: 'About', icon: Info },
    { path: '/contact', label: 'Contact', icon: MessageCircle },
    ...(token ? [{ path: '/assessment', label: 'Assessment', icon: LayoutDashboard }] : []),
    ...(!token && !admin ? [{ path: '/login', label: 'Login', icon: LogIn }] : [])
  ];

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
  }, [isOpen]);

  return (
    <nav className={`fixed top-0 left-0 right-0 py-2 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white'
      }`}>
      <div className="container mx-auto px-4 py-2 flex justify-between items-center h-14 lg:h-16 lg:px-16">
        <Link to="/" className="flex items-center group relative">
          <img
            src={Logo}
            alt="Logo"
            className="h-12 lg:h-14 transition-all duration-300 hover:brightness-110"
          />
        </Link>

        {/* Mobile Menu Button */}
        <button
          onClick={toggleMenu}
          className="lg:hidden w-10 h-10 flex items-center justify-center   transition-all duration-200 active:scale-95"
          aria-label="Toggle Menu"
        >
          {isOpen ? (
            <svg
              viewBox="0 0 24 24"
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                fill="none"
              />
            </svg>
          ) : (
            <svg
              viewBox="0 0 24 24"
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 6h18M3 12h18M3 18h18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                fill="none"
              />
            </svg>
          )}

        </button>

        {/* Navigation Links Container */}
        <div className={`
          fixed inset-0 bg-blue-50/95 backdrop-blur-lg
          lg:static lg:bg-transparent lg:backdrop-blur-none
          ${isOpen ? 'translate-x-0 opacity-100 ' : 'translate-x-full opacity-10'} 
          lg:translate-x-0 lg:opacity-100
          transition-all duration-300 ease-in-out
          top-[70px] lg:top-0
          lg:block
        `}>
          <ul className="
            flex flex-col lg:flex-row  bgcolor
            items-center justify-center 
            h-[calc(100vh-56px)] lg:h-auto
            space-y-4 lg:space-y-0 lg:space-x-6
            p-6 lg:p-0
          ">
            {navLinks.map((link) => {
              const LinkIcon = link.icon;
              const isActive = location.pathname === link.path;

              return (
                <li key={link.path} className="w-full lg:w-auto">
                  <Link
                    to={link.path}
                    className={`
                      flex items-center justify-center
                      px-6 py-4 lg:py-2
                      rounded-xl lg:rounded-lg
                      transition-all duration-300
                      ${isActive
                        ? 'bg-blue-500 text-white shadow-lg '
                        : 'hover:bg-blue-50 ]  hover:text-blue-600'}
                      text-sm font-medium
                      relative
                      group
                    `}
                    onClick={closeMenu}
                  >
                    <LinkIcon className={`
                      w-5 h-5 lg:hidden
                      ${isActive ? 'text-white' : 'text-blue-500'}
                      mr-3
                    `} />
                    <span className="tracking-wide">{link.label}</span>
                  </Link>
                </li>
              );
            })}

            {admin && (
              <li className="w-full lg:w-auto">
                <Link
                  to="/admin-dashboard"
                  className="
                    flex items-center justify-center
                    px-6 py-4 lg:py-2
                    bg-gradient-to-r from-blue-500 to-blue-600
                    text-white
                    rounded-xl lg:rounded-lg
                    shadow-lg shadow-blue-500/25
                    hover:shadow-xl hover:shadow-blue-500/30
                    transition-all duration-300
                    font-medium tracking-wide
                    text-sm
                  "
                  onClick={closeMenu}
                >
                  <LayoutDashboard className="w-5 h-5 lg:hidden mr-3" />
                  <span>Dashboard</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;